import { render, staticRenderFns } from "./OrganisationBilling.vue?vue&type=template&id=311b3366&"
import script from "./OrganisationBilling.vue?vue&type=script&lang=js&"
export * from "./OrganisationBilling.vue?vue&type=script&lang=js&"
import style0 from "./OrganisationBilling.vue?vue&type=style&index=0&id=311b3366&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports